import { useTranslation } from "react-i18next";

import { Modal } from "@/components/Interface/Modal/Modal.tsx";

/**
 * A question/answer section inside the "How it works" modal.
 * Renders a bold question heading, a horizontal divider, and answer paragraphs.
 */
const HowItWorksSection = ({
  question,
  answer,
  isLast = false,
}: {
  question: string;
  answer: string;
  isLast?: boolean;
}) => (
  <div className={isLast ? undefined : "mb-6"}>
    {/* h3: the modal's own title is the h2 of this dialog. */}
    <h3 className="mb-3 text-base font-semibold">{question}</h3>
    <hr className="mb-4 border-foreground-primary-inverse/20" />
    {answer.split("\n\n").map((paragraph) => (
      <p key={paragraph} className="mb-2 text-base font-normal last:mb-0">
        {paragraph}
      </p>
    ))}
  </div>
);

const questionKeys = [
  "eligibleSubscriptions",
  "flatMobileInactive",
  "numberPortingInProgress",
  "changingSubscription",
  "joinMoreGroups",
  "maxMemberLimitExceeded",
] as const;

/** The "How it works" question-and-answer dialog of the group overview. */
export const HowItWorksModal = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "friendsWithBenefits.groupOverview.howItWorksModal",
  });

  return (
    <Modal title={t("title")} onClose={onClose} variant="dark">
      <div>
        {questionKeys.map((questionKey, index) => (
          <HowItWorksSection
            key={questionKey}
            question={String(t(`${questionKey}Question` as never))}
            answer={String(t(`${questionKey}Answer` as never))}
            isLast={index === questionKeys.length - 1}
          />
        ))}
      </div>
    </Modal>
  );
};
